// Placeholder chrome for the first load, matching the real toolbar and panes
// closely enough that nothing jumps when the catalog arrives.

import React from 'react';
import { t } from '@lingui/macro';
import { H1 } from '@decisiv/ui-components/lib/components/Typography';
import Share from '@decisiv/iconix/lib/components/Share';

import Helmet from '../../components/SEO/Helmet';

export default function SkeletonView() {
  return (
    <div className="at-root">
      <Helmet title={t`Actions`} description={t`Actions`} />
      <div className="page">
        <div className="page-toolbar">
          <div className="page-title-row">
            <H1 className="page-title">
              <span className="at-skel-title-icon">
                <Share size="medium" />
              </span>
              {t`Actions`}
            </H1>
            <div className="actions">
              <span className="at-skel" style={{ width: 132, height: 32 }} />
            </div>
          </div>
          <div className="toolbar-row">
            <span className="at-skel" style={{ width: 280, height: 36 }} />
            <span
              className="at-skel"
              style={{ width: 60, height: 12, marginLeft: 12 }}
            />
            <span
              className="at-skel"
              style={{ width: 84, height: 24, borderRadius: 12 }}
            />
            <span
              className="at-skel"
              style={{ width: 110, height: 24, borderRadius: 12 }}
            />
            <span
              className="at-skel"
              style={{ width: 96, height: 24, borderRadius: 12 }}
            />
          </div>
        </div>
        <div className="body">
          <div className="list-pane">
            <div className="list-header">
              <span className="at-skel" style={{ width: 80, height: 11 }} />
              <span className="at-skel" style={{ width: 36, height: 11 }} />
            </div>
            <div className="list-scroll">
              {Array.from({ length: 7 }).map((_, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={i} className="at-skel-row">
                  <span
                    className="at-skel"
                    style={{ width: 28, height: 28, borderRadius: 6 }}
                  />
                  <div className="at-skel-row-info">
                    <span
                      className="at-skel"
                      style={{ width: `${55 + ((i * 7) % 30)}%`, height: 12 }}
                    />
                    <span
                      className="at-skel"
                      style={{ width: `${30 + ((i * 11) % 25)}%`, height: 9 }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="at-skel-detail">
            <div className="at-skel-detail-head">
              <span className="at-skel" style={{ width: 240, height: 22 }} />
              <span
                className="at-skel"
                style={{ width: 48, height: 22, borderRadius: 12 }}
              />
            </div>
            <span
              className="at-skel"
              style={{ width: '70%', height: 12, marginTop: 6 }}
            />
            <span className="at-skel" style={{ width: '50%', height: 12 }} />

            <div className="at-skel-section">
              <span className="at-skel" style={{ width: 90, height: 11 }} />
              <span
                className="at-skel"
                style={{
                  display: 'block',
                  width: '100%',
                  height: 140,
                  marginTop: 8,
                  borderRadius: 8,
                }}
              />
            </div>

            <div className="at-skel-section">
              <span className="at-skel" style={{ width: 160, height: 11 }} />
              <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                <span
                  className="at-skel"
                  style={{ width: 96, height: 24, borderRadius: 12 }}
                />
                <span
                  className="at-skel"
                  style={{ width: 120, height: 24, borderRadius: 12 }}
                />
                <span
                  className="at-skel"
                  style={{ width: 88, height: 24, borderRadius: 12 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
